<template>
  <div id="connection">
    <img :src="logo" alt="logo" />
    <!-- <br />
    <br />
    <br />
    <br />-->
    <h2 class="login-heading">
      <!-- <v-icon medium color="teal darken-2">settings</v-icon> -->
      Connect to your Dataset!
    </h2>&nbsp;&nbsp;
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field v-model="agent_email" label="E-mail" id="ta-appsettings-email" required variant="underlined" />
      <v-text-field v-model="agent_password" :rules="[rules.required, rules.min]" id="ta-appsettings-password" :type="show1 ? 'text' : 'password'"
        name="input-10-1" label="Password" @click:append="show1 = !show1" variant="underlined" />

      <v-snackbar v-model="snackbar" :multi-line="false" :timeout="6000" :location="'top'" :vertical="false">
        {{ snackbarText }}
        <template v-slot:actions>
        <v-btn color="pink" id="ta-appsettings-close"  variant="text" @click="snackbar = false">Close</v-btn>         
      </template>
      </v-snackbar>
      <v-btn class="bg-green-darken-1 white_text" @click="connect" id="ta-appsettings-selectdataset"
        :disabled="!valid || (agent_password === '' || agent_email === '')">Select Dataset</v-btn>
      <span style="margin-left: 16px;" />
      <v-btn @click="cancel">Cancel</v-btn>
      <br />
      <br />

      <v-progress-linear :indeterminate="true" height="5" color="green" v-if="isConnected" />
      <span class="text-grey" v-if="isConnectFailed">Agent Server is not responding.</span>
    </v-form>
    <v-dialog v-model="dialog" width="auto">
      <v-card>
        <v-card-title class="bg-green-darken-1" primary-title style="font-size: small;">Available Datasets</v-card-title>
        <v-card-text>Select a dataset to log in to:</v-card-text>
        <v-list lines="two">
          <v-list-item v-for="(item) in datasets" :key="item.TenantId" avatar ripple @click="selectDataset(item)" :class="'ta-dataset-'+item.TenantCode">
            <template v-slot:prepend>
              <!-- <v-icon size="large" >mdi-database</v-icon> -->
              <font-awesome-icon icon="database" size="2x" style="padding: 15px;" />
            </template>

            <!-- <v-icon size="large" >mdi-database</v-icon> -->
            <!-- <font-awesome-icon icon="database"  size="2x"/>  -->
            <v-list-item-title>{{ item.TenantName }}</v-list-item-title>
            <v-list-item-subtitle>{{ item.Description }}</v-list-item-subtitle>
          </v-list-item>
        </v-list>
        <v-divider />
      </v-card>
    </v-dialog>
  </div>
</template>

<script >
import * as Sentry from '@sentry/vue';
import foot1 from '@/assets/SalesReview.svg';
import DataService from '@/services/data-service';
import { agentBus } from '@/main';
import CryptoService from '@/services/crypto-services';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
const cryptoService = new CryptoService();
const dataService = new DataService();

export default {
  name: 'appSettings',
  loading: true,
  data: () => ({
    logo: foot1,
    agent_email: '',
    agent_password: '',
    agentInfo: [],
    datasets: [],
    snackbar: false,
    snackbarText: '',
    rules: {
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 8 || 'Min 8 characters',
      emailMatch: () => "The email and password you entered don't match",
    },
    valid: false,
    show1: false,
    select: false,
    dialog: false,
    isConnected: false,
    isConnectFailed: false,
  }),
  methods: {
    connect() {
      this.isConnected = true;
      this.isConnectFailed = false;
      if (this.agent_email !== '' && this.agent_password !== '') {
        dataService
          .connect(this.agent_email, this.agent_password)
          .then((success) => {
            if (success.Error) {
              this.snackbar = true;
              this.isConnectFailed = true;
              this.isConnected = false;
              this.snackbarText = success.Error === 'Error: Email/password not correct'
                ? 'Unable to authorize access due to a bad email address or password. If you continue to encounter the issue please contact your system administrator.'
                : 'Agent Server is not responding.';
            } else {
              console.log(success);
              this.agentInfo = success;
              this.$emit('agentConnected', this.agentInfo);
              if (success.Datasets) {
                this.datasets = success.Datasets;
                this.dialog = true;
                this.isConnected = false;
                this.isConnectFailed = false;
              }
            }
          })
          .catch((err) => {
            console.log(err);
            this.error = err;
            this.isConnected = false;
            this.isConnectFailed = true;
            this.snackbar = true;
            this.loading = false;
            this.snackbarText = 'Agent Server is not responding.';
          });
      }

      // this.$router.replace("/login");
    },
    selectDataset(item) {
      const agentData = {
        AgentId: this.agentInfo.AgentId,
        SessionID: this.agentInfo.SessionID,
        TenantId: item.TenantId,
        agentUser: this.agent_email,
        agentPassword: cryptoService.encryptString(this.agent_password),
      };
      localStorage.agentInfo = JSON.stringify(agentData);
      if (this.agent_email !== '') {
        const sentrytag = `${this.agent_email} - ${item.TenantName}`;
        localStorage.setItem('sentrytag', sentrytag);
        Sentry.configureScope((scope) => {
          scope.setTag('tenant', sentrytag);
        });
      }
      this.$store.commit('setAgentInfo', agentData);
      this.$router.replace('/login');
    },
    cancel() {
      this.$router.replace('/login');
    },
  },
};
</script>

<style>
body {
  background: #fff;
  font-family: Arial, Helvetica, sans-serif;
}

#connection {
  /* background: #fff;
  width: 30%;
  margin: auto auto auto auto; */
  border: 1px solid #ccc;
  padding: 2%;
  width: 30%;
  height: auto;
  background: #fff;

  position: absolute;
  /*it can be fixed too*/
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin-top: 70px;
  margin-bottom: 70px;
  margin-left: auto;
  margin-right: auto;

  /*this to solve "the content will not be cut when the window is smaller than the content": */
  max-width: 100%;
  max-height: 100%;
}

#connection img {
  width: 40%;
  height: 50%;
  display: block;
  margin: auto;
}

.page {
  position: fixed;
  width: inherit;
}

@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}

.router-anim-leave-active {
  animation: going 1s;
}

.white_text {
  color: white !important;
}

@keyframes going {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }

  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
